import { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';

function ManifestoItem() {
  const [open, setOpen] = useState(false);
  return (
    <div className="installation-menu-item-group">
      <button
        className="installation-menu-item"
        onClick={() => setOpen((v) => !v)}
        data-testid="menu-item-manifesto"
      >
        <span className="installation-menu-index">02</span>
        <span>ARTIST MANIFESTO</span>
      </button>
      <AnimatePresence>
        {open && (
          <motion.p
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="installation-menu-manifesto"
            data-testid="menu-manifesto-text"
          >
            "The object exists. The identity does not. Identity is a liability. Cryptography is the signature."
          </motion.p>
        )}
      </AnimatePresence>
    </div>
  );
}

function MenuNavItems({ onClose }) {
  return (
    <nav className="installation-menu-list">
      <Link
        to="/#vault"
        className="installation-menu-item"
        onClick={onClose}
        data-testid="menu-item-vault"
      >
        <span className="installation-menu-index">01</span>
        <span>VAULT PREVIEW</span>
      </Link>

      <ManifestoItem />

      <Link
        to="/"
        className="installation-menu-item"
        onClick={onClose}
        data-testid="menu-item-legacy"
      >
        <span className="installation-menu-index">03</span>
        <span>MAIN ARCHIVE</span>
      </Link>

      <a
        href="https://t.me/ZatoUK"
        target="_blank"
        rel="noopener noreferrer"
        className="installation-menu-item"
        data-testid="menu-item-contact"
      >
        <span className="installation-menu-index">04</span>
        <span>TRANSMIT SIGNAL (CONTACT)</span>
      </a>
    </nav>
  );
}

export function MenuOverlay({ open, onClose }) {
  return (
    <AnimatePresence>
      {open && (
        <motion.div
          className="installation-menu-overlay"
          data-testid="menu-overlay-container"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3, ease: 'easeOut' }}
        >
          <button
            className="installation-menu-close"
            onClick={onClose}
            data-testid="menu-close-button"
            aria-label="Close menu"
          >
            <X size={20} />
          </button>

          <MenuNavItems onClose={onClose} />

          <div className="installation-menu-footer">// ZATO SYSTEM // ROUTING TABLE</div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
